<modal
  [id]="modalId"
  [header]="'How invitation status works'"
  [closeButtonEnabled]="true"
  [widthClass]="'tw-w-[343px] lg:tw-w-[800px]'"
  [heightClass]="'tw-h-[640px] tw-max-h-[90vh]'"
  [showFooterDivider]="false"
>
  <div slot="body" class="tw-flex tw-flex-col tw-gap-6 tw-font-inter">
    <p class="tw-m-0 tw-w-full tw-text-sm tw-font-normal tw-leading-normal tw-text-gray-700 tw-font-inter">
      {{ intro }}
    </p>

    <app-delivery-channel-tabs [tabs]="tabs" [activeId]="activeChannel()" (tabChange)="onTabChange($event)" />

    <div class="tw-flex tw-w-full tw-flex-col tw-gap-4">
      <app-delivery-flow-chain [path]="activeHelp().path" />

      <div class="tw-flex tw-w-full tw-flex-col tw-gap-1 tw-rounded-lg tw-border tw-border-solid tw-border-yellow-300 tw-bg-yellow-50 tw-p-3">
        <div class="tw-flex tw-w-full tw-items-start tw-gap-2">
          <img [src]="assets.exclamation" alt="" class="tw-h-5 tw-w-5 lg:tw-h-4 lg:tw-w-4 tw-shrink-0" />
          <p class="tw-m-0 tw-flex-1 tw-text-xs tw-font-semibold tw-leading-normal tw-text-gray-700 tw-font-inter">WATCH OUT</p>
        </div>
        <p class="tw-m-0 tw-text-xs tw-font-medium tw-leading-normal tw-text-gray-500 tw-font-inter">
          {{ activeHelp().watchOut }}
        </p>
      </div>

      <app-delivery-status-table [rows]="activeHelp().statusRows" />
    </div>
  </div>
</modal>
